import Cookies from 'js-cookie';

import { User } from '@praetoid/client';

const USER_KEY = 'praetoid:user';
const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN as string | undefined;

export const getCurrentUser = (): User | null => {
	const current = Cookies.get(USER_KEY);
	if (!current) return null;

	try {
		return JSON.parse(current) as User;
	} catch {
		removeCurrentUser();
		return null;
	}
};

export const putCurrentUser = (current: User) => {
	Cookies.set(USER_KEY, JSON.stringify(current), {
		expires: 7,
		sameSite: 'lax',
		secure: globalThis.location?.protocol === 'https:',
		domain: COOKIE_DOMAIN
	});
};

export const removeCurrentUser = () => {
	Cookies.remove(USER_KEY, { domain: COOKIE_DOMAIN });
};
